export default {
  clientid: '54791899',
  uin: 722,
  session: 'F9B68564531E4822B4B8BFBED475BF76',
  trade_session: 'E6C9336D41EF454A87A5D16786B63166',
  rndkey: '438834e41f758c2519d7497a9a0aa6a9b6710bdd8cf39511ca114c0f623ce0c5',
  prdlocation: '0',
  region: 'HK',
  clientType: '2',
  curAccountId: '00003523644000000001',
  curAcctid: 325,
  curClientType: '3'
}
